/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import RouterService from '@ember/routing/router-service';

interface SetupGuideIntegrateSourceFooterArgs {
  isComplete: boolean;
}

export default class SetupGuideIntegrateSourceFooter extends Component<SetupGuideIntegrateSourceFooterArgs> {
  @service router!: RouterService;

  @computed('this.router.currentURL')
  get currentUrl() {
    return `${window.location.origin}${this.router.currentURL}`;
  }

  @action
  goToTeamSettings() {
    this.router.transitionTo('settings.team');
  }
}
